export const DEFAULT_AGENT_ID = "defaultAgent"
